import { markInputRule, markPasteRule } from '@tiptap/core';
import { Bold } from '@tiptap/extension-bold';

/* Regexes are slightly modified versions from the original ones in the @tiptap/extension-bold package. */

/**
 * Matches bold text via `**` as input. Does not allow whitespace at the start or end of the text.
 */
const starInputRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(\*\*([^*\s][^*]*[^*\s]|[^*\s])\*\*)$/;

/**
 * Matches bold text via `**` while pasting. Does not allow whitespace at the start or end of the text.
 */
const starPasteRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(\*\*([^*\s][^*]*[^*\s]|[^*\s])\*\*)/g;

/**
 * Matches bold text via `__` as input. Does not allow whitespace at the start or end of the text.
 */
const underscoreInputRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(__([^_\s][^_]*[^_\s]|[^_\s])__)$/;

/**
 * Matches bold text via `__` while pasting. Does not allow whitespace at the start or end of the text.
 */
const underscorePasteRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(__([^_\s][^_]*[^_\s]|[^_\s])__)/g;

export const ZyBold = Bold.extend({
    addInputRules() {
        return [
            markInputRule({
                find: starInputRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
            markInputRule({
                find: underscoreInputRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },

    addPasteRules() {
        return [
            markPasteRule({
                find: starPasteRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
            markPasteRule({
                find: underscorePasteRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },
});
